import { BillingSystem } from './billingSystem'

export interface CompanyDetails {
	tax: string
	phone: string
	email: string
	address: string
	name: string
}

export interface BankDetails {
	bankName: string
	taxId: string
	type: string
	accountName: string
	accountNumber: string
	fullAccountNumber: string
	currency: string
	swift: string
	address: string
	payTo: string
	routing: string
	alias: string
	clabe: string
	finalCreditAccount: string
}

export interface BillingDataCustom {
	municipality: string | null
	extNumber: string | null
	intNumber: string | null
	contabiliumFcType: string | null
	alegraPaymentMethod: string | null
	alegraPaymentType: string | null
	alegraCurrency: string | null
	invoiceLanguage: string | null
	alegraIdentificationType: string | null
	alegraIvaCondition: string | null
	alegraSaleCondition: string | null
	alegraSaleConcept: string | null
	alegraInvoiceType: string | null
	alegraPaymentForm: string | null
	alegraEconomicActivity: string | null
	alegraCommune: string | null
	alegraRegion: string | null
	alegraGiro: string | null
	regime: string | null
	useInvoiceNotifications: boolean
	sendOcEmailAutomatically: boolean
	ocNotificationEmails: string | null
	contactName: string | null
	contactPhone: string | null
	alegraIdentificationVerificationDigit: string | null
	alegraKindOfPerson: string | null
	alegraRegime: string | null
	alegraFirstname: string | null
	alegraLastname: string | null
	alegraTaxReason: string | null
	alegraTaxCause: string | null
}

export interface BillingDataDetails {
	id: number
	officialCompanyName: string
	tax: string
	country: string
	state: string
	city: string
	street: string
	zip: string
	custom: BillingDataCustom
	notificationEmails: string[]
	billingSystemId: number
}

export class BillingInfo {
	public alegraIso: string
	public paymentGateway: string
	public paymentMethod: string
	public companyDetails: CompanyDetails
	public bankDetails: BankDetails
	public tax: number
	public billingData: BillingDataDetails | null
	public billingSystem: BillingSystem | null

	constructor(data: {
		alegraIso: string
		paymentGateway: string
		paymentMethod: string
		companyDetails: CompanyDetails
		bankDetails: BankDetails
		tax: number
		billingData: BillingDataDetails | null
		billingSystem: BillingSystem | null
	}) {
		this.alegraIso = data.alegraIso
		this.paymentGateway = data.paymentGateway
		this.paymentMethod = data.paymentMethod
		this.companyDetails = data.companyDetails
		this.bankDetails = data.bankDetails
		this.tax = data.tax
		this.billingData = data.billingData
		this.billingSystem = data.billingSystem
	}

	static create(data: Partial<BillingInfo>): BillingInfo {
		const defaults: {
			alegraIso: string
			paymentGateway: string
			paymentMethod: string
			companyDetails: CompanyDetails
			bankDetails: BankDetails
			tax: number
			billingData: BillingDataDetails | null
			billingSystem: BillingSystem | null
		} = {
			alegraIso: '',
			paymentGateway: '',
			paymentMethod: '',
			companyDetails: {
				tax: '',
				phone: '',
				email: '',
				address: '',
				name: '',
			},
			bankDetails: {
				bankName: '',
				taxId: '',
				type: '',
				accountName: '',
				accountNumber: '',
				fullAccountNumber: '',
				currency: '',
				swift: '',
				address: '',
				payTo: '',
				routing: '',
				alias: '',
				clabe: '',
				finalCreditAccount: '',
			},
			tax: 0,
			billingData: null,
			billingSystem: null,
		}

		return new BillingInfo({ ...defaults, ...data })
	}

	/**
	 * Check if billing data exists (edit mode)
	 */
	hasBillingData(): boolean {
		return this.billingData !== null && this.billingData.id > 0
	}
}
